import { useTranslation } from "react-i18next";

export const useGetTitle = (title?: string, serviceId?: number) => {
  const { t } = useTranslation();

  return title ?? t("layout.tiles.activeSim.yourDevice");
};
